module.exports = __webpack_public_path__ + "img/durban-city-logo-icon.fde5b7db.png";